"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allAppsItems = void 0;
var allAppsItems = exports.allAppsItems = [{
  menuKey: 'auto-hosting',
  menuName: 'Auto Hosting',
  menuClass: 'bgc-auto-hosting'
}, {
  menuKey: 'automated-testing-tools',
  menuName: 'Automated Testing Tools',
  menuClass: 'bgc-automated-testing-tools'
}, {
  menuKey: 'career-website',
  menuName: 'Career Website',
  menuClass: 'bgc-career-website'
}, {
  menuKey: 'developer-career-success',
  menuName: 'Developer Career Success',
  menuClass: 'bgc-developer-career-website'
}, {
  menuKey: 'email-marketing',
  menuName: 'Email Marketing',
  menuClass: 'bgc-email-marketing'
}, {
  menuKey: 'job-board',
  menuName: 'Job Board',
  menuClass: 'bgc-job-board'
}, {
  menuKey: 'postmatch',
  menuName: 'Postmatch',
  menuClass: 'bgc-postmatch'
}, {
  menuKey: 'responsiveness-test',
  menuName: 'Responsiveness Test',
  menuClass: 'bgc-responsiveness-test'
}, {
  menuKey: 'tpm-dashboard',
  menuName: 'TPM Dashboard',
  menuClass: 'bgc-tpm-dashboard'
}, {
  menuKey: 'turing-com',
  menuName: 'Turing.com',
  menuClass: 'bgc-turing-com'
}, {
  menuKey: 'turing-ly-dashboard',
  menuName: 'Turing.ly Dashboard',
  menuClass: 'bgc-turing-ly-dashboard'
}];